import { LoadState } from "../../constants/enums";


export interface IMyCommissionReportState {
  list: IMyCommissionReport[];
   loading: LoadState;
}

export interface IMyCommissionReport {
  "accn_my_commission_report_id":string | null;
  "commission_report_code": string | null;
  "report_code": string | null;
  "user_fact_id":string | null;
  "incremental_number":string | null;
  "sub_type": string | null;
  "producer_code": string | null;
  "producer_email": string | null;
  "producer_status": string | null;
  "branch_code": string | null;
  "name": string | null;
  "time": string | null;
  "non_active_firm": string | null;
  "employment_status": string | null;
  "employee_number": string | null;
  "report_type": string | null;
  "total_premium": string | null;
  "total_commission":string | null;
  "total_house": string | null;
  "total_branch":string | null;
  "total_producer":string | null;
  "total_invoices":string | null;
  "total_payables":string | null;
  "from_date": string | null;
  "to_date": string | null;
  "status": string;
  attachment: string[] | null;
}

export const initialMyCommissionReportState: IMyCommissionReportState = {
  list: [],
  loading: LoadState.NotLoaded,
};